<template>
  <div>
    <div v-if="loadingContent" class="col-md-12 waiting-list">
      <div class="waiting-list__content">
        <div class="waiting-list__spinner">
          <div class="rect1"></div>
          <div class="rect2"></div>
          <div class="rect3"></div>
          <div class="rect4"></div>
          <div class="rect5"></div>
        </div>
      </div>
    </div>
    <slot v-else/>
  </div>
</template>

<script>
export default {
  name: "waitingList",
  props: {
    loadingContent: {
      default: false
    }
  },
}
</script>

<style lang="scss" scoped>

.waiting-list {
  &__content {
    background: #ffffff;
    border-radius: 10px !important;
    margin-bottom: 30px;
    min-height: 300px;
    display: flex;
    width: 100%;
    flex-direction: column;
    justify-content: center;
    margin-top: 30px;
  }

  &__spinner {
    height: 64px;
    text-align: center;

    .rect2 {
      -webkit-animation-delay: -1.1s;
      animation-delay: -1.1s;
    }

    .rect3 {
      -webkit-animation-delay: -1.0s;
      animation-delay: -1.0s;
    }

    .rect4 {
      -webkit-animation-delay: -0.9s;
      animation-delay: -0.9s;
    }

    .rect5 {
      -webkit-animation-delay: -0.8s;
      animation-delay: -0.8s;
    }

    > div {
      margin-right: 4px;
      background-color: #2F23D6;
      width: 8px;
      height: 64px;
      display: inline-block;
      -webkit-animation: sk-stretchdelay 1.2s infinite ease-in-out;
      animation: sk-stretchdelay 1.2s infinite ease-in-out;
    }
  }
}

/* Seletor de modificador */
.waiting-list {
  &--loading {
    &__content {
      /* ... */
    }

    &__spinner {
      /* ... */
    }
  }
}

@-webkit-keyframes sk-stretchdelay {
  0%,
  40%,
  100% {
    -webkit-transform: scaleY(0.4);
  }

  20% {
    -webkit-transform: scaleY(1.0);
  }
}

@keyframes sk-stretchdelay {
  0%,
  40%,
  100% {
    transform: scaleY(0.4);
    -webkit-transform: scaleY(0.4);
  }

  20% {
    transform: scaleY(1.0);
    -webkit-transform: scaleY(1.0);
  }
}

</style>



// WEBPACK FOOTER //
// src/vue/pages/components/layouts/waitingList.vue